import { makeStyles, Theme, createStyles } from '@material-ui/core/styles'
import * as React from 'react'

import Box from '../base/Box'
import Typography, { TypographyProps } from '../base/Typography'
import IconButton from '../button/IconButton'

export type HistoryBackProps = {
  goBack?(): void
  label?: string
  space?: number
  buttonIconSize?: 'small' | 'medium' | 'large'
  buttonSize?: 'small' | 'medium'
} & TypographyProps

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    icon: {
      transform: 'rotate(180deg)',
      color: theme.palette.common.black
    }
  })
)

const HistoryBack: React.FC<HistoryBackProps> = (props) => {
  const classes = useStyles()
  const {
    goBack = () => {},
    label,
    buttonIconSize,
    buttonSize,
    variant,
    space
  } = props
  return (
    <Box display="flex" alignItems="center">
      <Box marginRight={space ? space : 2}>
        <IconButton
          onClick={() => goBack()}
          className={classes.icon}
          iconSize={buttonIconSize ? buttonIconSize : 'large'}
          size={buttonSize ? buttonSize : 'small'}
          iconName="ArrowRightLongIcon"
        />
      </Box>
      <Typography
        children={label ? label : 'Label'}
        variant={variant ? variant : 'h4'}
      />
    </Box>
  )
}

export default HistoryBack
